export default __webpack_public_path__ + "static/media/2022-04-19_14h46_14.cbdc2e43.jpg";